import Api from '@api/setMealManage'
import { getImageAutoOrientLink } from '@util'
import { message, Modal } from 'hljd'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import omit from 'lodash/omit'
import { observable, toJS } from 'mobx'
import { isWeddingRingJewelryProperty } from '@merchant-backend/util'
import React from 'react'
import SessionCaseStore from './Detail/SetMealEditor/SessionCase/store'
// 子模块store
import SessionPictureStore from './Detail/SetMealEditor/SessionPicture/store'
import SessionServiceStore from './Detail/SetMealEditor/SessionService/store'
import styles from './style.module.less'
import { formatGetItineraryList, formatItineraryList } from './utils/format'
export default class {
  constructor(centerStore) {
    this.centerStore = centerStore
    this.property_id = centerStore.property_id
    this.id = centerStore.id
    this.isSingle = centerStore.isSingle
    this.sessionPictureStore = new SessionPictureStore(this)
    this.sessionServiceStore = new SessionServiceStore(this)
    this.sessionCaseStore = new SessionCaseStore(this)
  }

  initAnchor = () => {
    if (isWeddingRingJewelryProperty()) {
      this.anchor.pop()
    }
  }

  @observable
  anchor = [
    {
      key: 1,
      text: '图文介绍',
      active: true
    },
    {
      key: 2,
      text: '服务内容',
      active: false
    },
    {
      key: 3,
      text: '相关案例',
      active: false
    }
  ]

  @observable sessionPictureData = []
  @observable sessionService = []
  @observable sessionServiceSort = []
  @observable sessionCase = []
  @observable cover_path = {} // 横图
  @observable vertical_image = {} // 竖图
  @observable listOrder = ['0', '1', '2', '3', '4'] // 头图相关
  @observable video = {} // 视频

  @observable headImgList = [] // 头图列表

  @observable stepTwoData = {}

  onUploadHeadImgs = (url, info) => {
    const clipUrl = getImageAutoOrientLink(url, info)
    let obj = {
      clipUrl,
      width: info.width,
      height: info.height
    }
    this.headImgList.push(obj)
    this.headImgList = [...this.headImgList]
  }

  onRemoveHeadImg = index => {
    this.headImgList.splice(index, 1)
    this.headImgList = [...this.headImgList]
  }

  onHeadImgSort = list => {
    this.headImgList = list
  }

  onHeadImgCliped = ({ index, clipUrl, pixel }) => {
    this.headImgList[index] = {
      clipUrl: getImageAutoOrientLink(clipUrl),
      width: pixel.width,
      height: pixel.height
    }
    this.headImgList = [...this.headImgList]
  }

  /** 获取详情后的操作 */
  afterGetDetail = async detail => {
    const {
      set_meal_detail,
      merchandise_params,
      merchandise_params_sort,
      merchandise_params_deleted,
      cover_path,
      vertical_image,
      merchandise_items,
      set_meal_relation: _set_meal_relation
    } = detail

    const data = {
      merchandise_items, // 头图&视频
      set_meal_detail,
      merchandise_params,
      merchandise_params_sort,
      merchandise_params_deleted: isEmpty(toJS(merchandise_params_deleted))
        ? {}
        : merchandise_params_deleted.reduce((acc, cur) => {
            acc[cur] = 1 // 把merchandise_params_deleted里的值都变为1  对应业务是：即使模块已删除，在编辑的时候也显示出来
            return acc
          }, {}),
      cover_path: cover_path ? { clipUrl: cover_path } : '', // 横图
      vertical_image: vertical_image ? { clipUrl: vertical_image } : '' // 竖图
    }

    const headImgList = []
    // 头图
    let count = 0
    merchandise_items.forEach(item => {
      if (item.kind == 1) {
        let obj = {
          ...item,
          pixel: { height: item.height },
          clipUrl: item.media_path
        }
        headImgList.push({
          clipUrl: item.media_path,
          width: item.width,
          height: item.height
        })
        data[`headImg_${count}`] = obj
        count += 1
      }
      if (item.kind == 2) {
        let obj = {
          ...item,
          link: item.media_path
        }
        data[`video`] = obj
      }
    })

    data.headImgList = headImgList

    let set_meal_relation = []
    let setMealRelationApi = Api.getSetmealRelation
    let param = { set_meal_id: this.id }

    if (this.centerStore.isDraft) {
      // 草稿箱与已发布接口不同
      setMealRelationApi = Api.getDraftSetmealRelation
      const setMealIds = (_set_meal_relation || [])
        .map(({ example_id }) => example_id)
        .join(',')
      param = {
        setMealIds
      }
      if (!setMealIds) {
        param = null
      }
    }

    if (this.id && param) {
      const { data } = await setMealRelationApi(param)
      set_meal_relation = (data && data.list) || []
      set_meal_relation = set_meal_relation.map(el => {
        const { set_meal, ...rest } = el
        return {
          data: {
            ...set_meal,
            ...rest,
            id: rest.example_id
          },
          status: false
        }
      })
      data.set_meal_relation = set_meal_relation
    }

    this.stepTwoData = data

    this.headImgList = headImgList

    this.sessionPictureData = set_meal_detail
    this.sessionService = merchandise_params
    this.sessionServiceSort = merchandise_params_sort
    this.sessionServiceDeleted = merchandise_params_deleted
    this.sessionCase = set_meal_relation
    this.cover_path = data.cover_path
    this.vertical_image = data.vertical_image
    this.video = data.video
    // 旅拍-行程迭代
    // 为什么在这里赋值？旅拍迭代特殊逻辑，不确定后面有什么逻辑会修改源数据，因此在这里进行操作
    this.sessionServiceStore.initItineraryList(
      formatGetItineraryList(merchandise_params?.itinerary_list)
    )

    await Promise.all([
      this.sessionPictureStore.init(),
      this.sessionServiceStore.init(),
      this.sessionCaseStore.init()
    ])
  }

  // onChange
  onValueChange = type => value => {
    this[type] = value
    this.stepTwoData[type] = value
    if (type.includes('head')) {
      this.stepTwoData = { ...this.stepTwoData }
    }
  }

  /** 格式化第二步数据 */
  formatStepTwoData = () => {
    const param = this.stepTwoData

    // 处理图片和视频
    const headImgList = this.headImgList

    const list = ['1', '2', '3', '4', '5']
    let merchandise_items = []
    list.forEach((item, index) => {
      // 获取headImg
      let val = headImgList[index]
      // 头图之前存在时，需要把信息传回去
      let origin = this.id
        ? this.centerStore.detailData[`headImg_${index}`]
        : {}
      if (val) {
        let obj = {
          ...origin,
          kind: 1,
          is_head: 1,
          height: val.height,
          width: val.width,
          media_path: val.clipUrl
        }
        merchandise_items.push(obj)
      }
    })

    //视频处理
    let val = param.video
    let origin = this.id ? this.centerStore.detailData.video : {}
    let video =
      val && val.link
        ? {
            kind: 2,
            persistent_id: val.persistent_id,
            cover_path: val.cover_path,
            media_path: val.link,
            width: val.width,
            height: val.height,
            isHead: 1
          }
        : {}

    let obj = {
      ...origin,
      ...video
    }
    if (obj.kind) {
      merchandise_items.push(obj)
    }

    let {
      set_meal_detail = [],
      merchandise_params = {},
      merchandise_params_sort = {},
      merchandise_params_deleted = [],
      set_meal_relation = []
    } = param

    // 图片
    set_meal_detail = set_meal_detail.map(el => {
      const {
        kind,
        content: { status, ...rust }
      } = el
      return {
        kind,
        content: { ...rust }
      }
    })

    // 关联套餐
    set_meal_relation = set_meal_relation.map((el, i) => ({
      example_id: el.data.example_id,
      example_weight: i
    }))

    // 处理数字输入框单位
    const service = this.sessionServiceStore.sourceServiceConfig
      .map(el => el.childNodes)
      .reduce((pre, curr) => {
        pre = [...pre, ...curr]
        return pre
      }, [])
    let merchandise = cloneDeep(toJS(merchandise_params))
    merchandise = Object.keys(merchandise_params).reduce((pre, curr) => {
      if (curr !== 'age_begin' && curr !== 'age_end') {
        const current = service.find(el => el.key === curr)
        const value = merchandise_params[curr]
        // 如果值是空数组或空对象，忽略这个值
        if (
          current &&
          current !== 'jewelry_type' &&
          !(typeof value === 'object' && isEmpty(value))
        ) {
          if (
            current.type === 'inputNumber' ||
            current.type === 'precisionInput'
          ) {
            pre[`${curr}_unit`] = current.unit
          }
          pre[curr] = value
        }

        const currentUnitItem = service.find(el => el.unitKey === curr)
        if (currentUnitItem) {
          pre[curr] = merchandise_params[curr]
        }
      } else {
        pre[curr] = merchandise_params[curr]
      }
      return pre
    }, {})

    Object.keys(merchandise).forEach(key => {
      if (!merchandise[key]) {
        return (merchandise[key] = undefined)
      }
    })

    console.log('merchandise', merchandise)

    const res = omit(
      {
        set_meal_detail,
        merchandise_params: merchandise,
        merchandise_params_sort,
        merchandise_params_deleted,
        set_meal_relation,
        // 图片 、 视频
        cover_path: param.cover_path ? param.cover_path.clipUrl : '',
        vertical_image: param.vertical_image
          ? param.vertical_image.clipUrl
          : '',
        merchandise_items
      },
      ['headImg_0', 'headImg_1', 'headImg_2', 'headImg_3', 'headImg_4', 'video']
    )

    if (this.property_id == 12 && this.isSingle == 1) {
      // 发布单品
      res.set_meal_single_product = {
        type: this.centerStore.gender == 1 ? 1 : 2, // 性别
        category_id:
          this.centerStore.gender == 1
            ? merchandise.clothing_type
            : merchandise.clothes_type
      }
    }
    // 修改行程
    res.merchandise_params.itinerary_list = this.handleFormatItineraryList()
    return res
  }

  /**
   * @title 处理行程提交数据
   */
  handleFormatItineraryList = () => {
    const itineraryList = formatItineraryList(
      this.sessionServiceStore.itineraryList
    )
    return itineraryList
  }

  /** 获取头图顺序 */
  getImgOrder = (value, oldIndex, newIndex) => {
    let data = cloneDeep(toJS(this.stepTwoData))
    let oldValue = data[`headImg_${oldIndex}`]
    let newValue = data[`headImg_${newIndex}`]
    data[`headImg_${oldIndex}`] = newValue
    data[`headImg_${newIndex}`] = oldValue

    this.stepTwoData = data
  }

  /** 检查图片数量是否大于3 */
  imgCountCheck = () => {
    let imgCount = 0
    this.listOrder.forEach((item, index) => {
      if (this.stepTwoData[`headImg_${index}`]) {
        imgCount++
      }
    })

    if (imgCount >= 3) {
      // 数量大于3
      return true
    } else {
      message.error('请上传三张以上图片')
      return false
    }
  }

  /** 修改视频尺寸攻略弹窗 */
  howToResizeVideoModal = () => {
    Modal.info({
      maskClosable: true,
      title: '修改视频尺寸攻略',
      width: 800,
      centered: true,
      content: (
        <video
          className={styles['hlj-cut-video']}
          controls
          src="//qnm.hunliji.com/o_1cjkbr6a61gt31t3j1ij9vgv1d6o7.mp4"
        />
      ),
      onOk() {}
    })
  }

  /** 切换tab */
  changeAnchor = key => {
    this.anchor = this.anchor.map(item => {
      item.active = item.key === key
      return item
    })
  }

  setStepTwoData = () => {
    // 存储第二步的数据
    this.stepTwoData = {
      ...this.stepTwoData,
      set_meal_detail: toJS(this.sessionPictureData),
      merchandise_params: toJS(this.sessionService),
      merchandise_params_sort: toJS(this.sessionServiceSort),
      merchandise_params_deleted: toJS(this.sessionServiceDeleted),
      set_meal_relation: toJS(this.sessionCase)
    }
  }

  /** 校验stepTwoData */
  validateData = () => {
    // 检查封面和头图
    if (!this.validateImgs()) return false

    // 校验服务内容
    if (!this.sessionServiceStore.validateServiceData()) return false

    return true
  }

  /** 校验套餐封面和头图 */
  validateImgs = () => {
    let { set_meal_detail, cover_path, vertical_image } = this.stepTwoData

    // 检查套餐封面
    if (!cover_path || !cover_path.clipUrl) {
      message.warning(`请上传${this.isSingle ? '单品' : '套餐'}封面`)
      return false
    }

    // 检查套餐方(竖)图
    if (!vertical_image || !vertical_image.clipUrl) {
      message.warning(
        `请上传${this.isSingle ? '单品' : '套餐'}${
          this.property_id == 12 ? '竖图' : '方图'
        }`
      )
      return false
    }

    // 检查头图数量
    const headImgList = this.headImgList
    let headImgCount = headImgList.length
    if (headImgCount < 3) {
      message.warning('请上传三张以上套餐头图！')
      return false
    }

    // 检查图文介绍(set_meal_detail)中图片数量
    if (
      !toJS(set_meal_detail) ||
      (toJS(set_meal_detail) || []).filter(el => el.kind == 1).length < 3
    ) {
      message.warning('图文编辑需要上传至少3张图片！')
      return false
    }

    return true
  }
}
